export default __webpack_public_path__ + "2cdf1bae63c64c3d17aed68bf2703d55.jpg";